(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/digital-tickets/components/login-register/login-register.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/digital-tickets/components/login-register/login-register.js');
"use strict";


const {
  PASSWORD_RECOVERY,
  DIGITAL_TICKETS
} = svs.ticket_partner.constants.routes;
const {
  Link
} = svs.app.ReactRouter;
const Email = svs.ui.reactFormInputs.EmailInput;
const TextInput = svs.ui.reactFormInputs.TextInput;
const {
  Form,
  ControlGroup
} = svs.ui.reactForm;
const {
  useState
} = React;
const {
  Grid,
  GridRow,
  GridCol
} = svs.ui.ReactGrid;
const {
  EMAIL_LABEL,
  EMAIL_MAX,
  EMAIL_REQUIRED_ERROR,
  EMAIL_NAME
} = svs.ticket_partner.digitalTickets.loginRegister.constants.FORMS.EMAIL;
const {
  PASSWORD_LABEL,
  PASSWORD_NAME,
  PASSWORD_REQUIRED_ERROR
} = svs.ticket_partner.digitalTickets.loginRegister.constants.FORMS.PASSWORD;
const Button = svs.ui.ReactButton;
const {
  LOGIN_HEADER,
  LOGIN_INGRESS,
  LOGIN_REGISTER,
  PASSWORD_LINK,
  LOGIN_CREATE_ACCOUNT
} = svs.ticket_partner.digitalTickets.loginRegister.constants.FORMS;
const Login = () => {
  const [isLarge] = svs.ticket_partner.sharedComponents.hooks.useBreakpointGreaterThan('sm');
  const {
    login
  } = svs.ticket_partner.useUserContext();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const handleSubmit = async (e, formData) => {
    e && e.preventDefault();
    if (_.values(formData).filter(field => !field.isValid).length === 0) {
      svs.ui.loader.show();
      await login(email, password);
      svs.ui.loader.hide();
    }
  };
  return React.createElement(Form, {
    onSubmit: handleSubmit
  }, React.createElement("h2", {
    className: "f-bold u-text-left"
  }, LOGIN_HEADER), React.createElement("span", {
    className: "u-text-left"
  }, LOGIN_INGRESS), React.createElement(GridRow, null, React.createElement(GridCol, {
    am: {
      col: 5
    },
    sm: {
      col: 12
    }
  }, React.createElement(Email, {
    errorMessageRequired: EMAIL_REQUIRED_ERROR,
    id: EMAIL_NAME,
    isRequired: true,
    label: EMAIL_LABEL,
    max: EMAIL_MAX,
    name: EMAIL_NAME,
    onChange: e => setEmail(e.target.value),
    value: email
  })), React.createElement(GridCol, {
    am: {
      col: 5
    },
    sm: {
      col: 12
    }
  }, React.createElement(TextInput, {
    errorMessageRequired: PASSWORD_REQUIRED_ERROR,
    id: PASSWORD_NAME,
    isRequired: true,
    label: PASSWORD_LABEL,
    name: PASSWORD_NAME,
    onChange: e => setPassword(e.target.value),
    type: "password",
    value: password
  })), React.createElement(GridCol, {
    am: {
      col: 2
    },
    className: "u-text-center",
    sm: {
      col: 12
    }
  }, React.createElement(ControlGroup, {
    v2: true
  }, React.createElement(Button, {
    block: isLarge,
    className: !isLarge ? 'button-width-150' : '',
    inverted: true,
    type: "submit"
  }, "Logga in")))), React.createElement(GridRow, null, React.createElement("div", {
    className: "padding-top-2 ".concat(isLarge ? 'u-text-right' : 'u-text-center')
  }, React.createElement(Link, {
    to: "".concat(PASSWORD_RECOVERY, "?returnUrl=").concat(DIGITAL_TICKETS)
  }, PASSWORD_LINK))));
};
const RegisterNewCustomer = _ref => {
  let {
    handleNewCustomer
  } = _ref;
  const [isLarge] = svs.ticket_partner.sharedComponents.hooks.useBreakpointGreaterThan('sm');
  return React.createElement(GridRow, null, React.createElement("h2", {
    className: "f-bold u-text-left"
  }, LOGIN_REGISTER, ' '), React.createElement(GridCol, {
    am: {
      col: 10
    },
    className: "u-text-left u-flex u-flex-align-items-center",
    sm: {
      col: 12
    }
  }, "Slutf\xF6r din best\xE4llning och skapa ditt f\xF6retagskonto p\xE5 samma g\xE5ng."), React.createElement(GridCol, {
    am: {
      col: 2
    },
    className: "u-text-center",
    sm: {
      col: 12
    }
  }, React.createElement(Button, {
    block: isLarge,
    className: !isLarge ? 'button-width-150' : '',
    inverted: true,
    onClick: handleNewCustomer
  }, LOGIN_CREATE_ACCOUNT)));
};
const LoginRegister = _ref2 => {
  let {
    handleNewCustomer
  } = _ref2;
  return React.createElement(Grid, null, React.createElement(Login, null), React.createElement(RegisterNewCustomer, {
    handleNewCustomer: handleNewCustomer
  }));
};
svs.ticket_partner.digitalTickets.loginRegister.LoginRegister = LoginRegister;

 })(window);